/** @jsxImportSource @emotion/react */
import React from 'react'
import { OrderGrid } from '@components/systems'

// NOTE: 간단히(좌-우 분할) 뷰 및 세로 탭은 임시 숨김 처리.
// 복구가 필요하면 이 파일의 git history 참고 (탭 전환 + OrderList/OrderDetail 구성).
const OrderPage = () => {
	return <OrderGrid />
}

export default OrderPage
